// submit.js

import { useState, useEffect } from 'react';
import { useStore } from './store';
import { shallow } from 'zustand/shallow';

const selector = (state) => ({
    nodes: state.nodes,
    edges: state.edges,
});

export const SubmitButton = () => {
    const { nodes, edges } = useStore(selector, shallow);
    const [toast, setToast] = useState(null); // { num_nodes, num_edges, is_dag }
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    // Auto-hide toast after 5 seconds
    useEffect(() => {
        if (toast) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
                setTimeout(() => setToast(null), 400); // wait for fade-out animation
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('pipeline', JSON.stringify({ nodes, edges }));

            const response = await fetch('http://127.0.0.1:8000/pipelines/parse', {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            setToast(data);
        } catch (error) {
            console.error('Error parsing pipeline:', error);
            setToast({ error: true });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Submit Button */}
            <div className="submit-container">
                <button
                    className="submit-btn"
                    type="button"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? (
                        <span className="submit-btn-loading">
                            <span className="spinner" />
                            Analyzing...
                        </span>
                    ) : 'Submit Pipeline'}
                </button>
            </div>

            {/* Toast Notification */}
            {toast && (
                <div className={`toast ${toast.error ? 'toast-error' : ''} ${visible ? 'toast-visible' : ''}`}>
                    {toast.error ? (
                        <>
                            <div className="toast-icon">⚠️</div>
                            <div className="toast-body">
                                <div className="toast-title">Connection Error</div>
                                <div className="toast-msg">Ensure the backend is running on port 8000.</div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="toast-icon">{toast.is_dag ? '✅' : '🔄'}</div>
                            <div className="toast-body">
                                <div className="toast-title">Pipeline Analysis</div>
                                <div className="toast-stats">
                                    <span className="toast-stat"><b>{toast.num_nodes}</b> Nodes</span>
                                    <span className="toast-divider">·</span>
                                    <span className="toast-stat"><b>{toast.num_edges}</b> Edges</span>
                                    <span className="toast-divider">·</span>
                                    <span className={`toast-dag ${toast.is_dag ? 'dag-valid' : 'dag-invalid'}`}>
                                        {toast.is_dag ? 'Valid DAG' : 'Has Cycles'}
                                    </span>
                                </div>
                            </div>
                            <div className="toast-progress">
                                <div className={`toast-progress-bar ${toast.is_dag ? '' : 'toast-progress-error'}`} />
                            </div>
                        </>
                    )}
                    <button className="toast-close" onClick={() => { setVisible(false); setTimeout(() => setToast(null), 400); }}>✕</button>
                </div>
            )}
        </>
    );
}
